import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { Link } from 'components/common';
import { ErrorImage } from '.';

const ErrorPage404 = () => {
  const {
    language,
    messages,
    serverConfig: { accountGuestEnableHomePage, custom404Pages },
    theme,
    user
  } = useReduxState();

  const { asPath } = useRouter();

  const pageMatch = custom404Pages?.find((page) =>
    new RegExp(page.matchPathRegex).test(asPath)
  );

  return (
    <>
      {pageMatch ? (
        <>
          <div className="title">
            {pageMatch?.titleTranslations?.[language] || pageMatch?.title}
          </div>
          <div
            className="custom-message"
            dangerouslySetInnerHTML={{
              __html:
                pageMatch.contentTranslations?.[language] || pageMatch.content
            }}
          />
        </>
      ) : (
        <>
          <ErrorImage />
          <div className="title">{messages.errorNotFound}</div>
          <p className="description">{messages.errorNotFoundInfo}</p>
        </>
      )}

      {user?.roles.includes('user') ||
        (accountGuestEnableHomePage && (
          <div className="link">
            <Link href="/" text={messages.errorGoToMainPage} />
          </div>
        ))}

      <style jsx>{`
        .title {
          color: ${theme.textColor};
          font-size: 2rem;
          font-weight: 700;
          margin: 5px 0 10px;
        }
        .description,
        .custom-message :global(> p) {
          color: ${theme.textColorLighter};
          margin: 10px 0;
        }
        .custom-message :global(> p > a) {
          color: ${theme.linkColor};
          font-weight: 600;
          text-decoration: none;
        }
        .custom-message :global(> p > a:hover) {
          text-decoration: underline;
        }
        .link {
          margin-top: 25px;
        }
      `}</style>
    </>
  );
};

export default ErrorPage404;
